/* eslint-disable import/no-anonymous-default-export */
import "./MainLayout.scss";
import Header from "../Header";  
import Sidebar from "../Sidebar";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallbackComponent from "../../../_uiComponents/ErrorFallbackComponent";
import useMainLayout from "./useMainLayout";
export default ({ activeMenuItem, children, pageName ,user, handleResumeUploadModal, onShare }) => {
  const { menuOpen, menuOpenHandler } = useMainLayout();
  return (
    <ErrorBoundary fallback={<ErrorFallbackComponent />}>
      <div className="main-layout">
        <Header pageName={pageName} menuOpenHandler={menuOpenHandler} />
        <Sidebar
          activeMenuItem={activeMenuItem}
          menuOpen={menuOpen}
          menuOpenHandler={menuOpenHandler}
          handleResumeUploadModal={handleResumeUploadModal}
          onShare={onShare}
          user={user}
        />
        <div className="main-container">{children}</div>
      </div>
    </ErrorBoundary>
  );
};
